module.exports = __webpack_public_path__ + "static/media/comfort-experts.08327729.png";